<template>
  <div>
    <div class="set-title flex">
      <div><span>{{ templateName }}</span></div>
    </div>
    <div class="flex flex-jb">
      <div class="faultBtn">
        <div :class="rebateTypeTab === '01' ? 'active' : 'none'" @click="rebateBtnClick('01')">
          比例设置
        </div>
        <div :class="rebateTypeTab === '02' ? 'active' : 'none'" @click="rebateBtnClick('02')">
          机型设置
        </div>
      </div>
    </div>
    <!-- 比例设置 -->
    <RegionListTable v-if="rebateTypeTab == '01'" :data="regionList" @change="regionListChange" />
    <div v-if="rebateTypeTab == '02'">
      <span style="font-size: 13px; font-weight: bold;margin-right: 15px">已设置{{ machineIds.length }}个机型</span>
      <el-link
        type="primary"
        :underline="false"
        @click="openMachineListDia"
        >查看机型</el-link
      >
    </div>
    <!-- 新增规则 -->
    <RegionDia ref="regionDia" @confirm="addRegion" />
    <!-- 管理机型 -->
    <MachineListDia ref="machineListDia" :omitIds="omitIds" :machineIds="machineIds" @confirm="machineIdsChange" />
    <RegionDelDia ref="regionDelDia" @confirm="$emit('del')" />
  </div>
</template>

<script>
import RegionListTable from '../table/RegionListTable.vue';
import MachineListDia from "./MachineListDia.vue";
import RegionDia from '../dialog/RegionDia.vue';
import RegionDelDia from '../dialog/RegionDelDia.vue';
export default {
  name: "MachineTemplateList",
  components: {
    MachineListDia,
    RegionListTable,
    RegionDia,
    RegionDelDia
  },
  props: {
    templateName: String,
    regionList: {
      type: Array,
      default: () => []
    },
    machineIds: {
      type: Array,
      default: () => []
    },
    index: Number,
    machineTemplateList: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      rebateTypeTab: "01",
      omitIds: []
    };
  },
  methods: {
    rebateBtnClick(type) {
      this.rebateTypeTab = type;
    },
    addRegion(data) {
      const { regionList } = this
      // 只有新增判断不连续
      if (regionList && regionList.length) {
        const lastItem = regionList[regionList.length - 1]
        if (data.lower != lastItem.upper) {
          this.$message.error("价位区间不连续");
          return
        }
      }
      this.$emit('change', {
        regionList: [...regionList, data],
        machineIds: this.machineIds
      })
      // this.regionList.push(data)
      this.$refs['regionDia'].close()
    },
    regionListChange(list) {
      this.$emit('change', {
        regionList: list,
        machineIds: this.machineIds
      })
    },
    openMachineListDia() {
      const omitIds = this.machineTemplateList.reduce((prev, item) => {
        if (item.templateName != this.templateName) {
          prev.push(...item.machineIds)
        }
        return prev
      }, [])
      this.omitIds = omitIds
      this.$refs['machineListDia'].open()
    },
    machineIdsChange(idList) {
      this.$emit('change', {
        machineIds: idList
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.set-title {
  font-weight: bold;
  color: #333333;
  font-size: 16px;
  height: 16px;
  padding-left: 10px;
  border-left: 3px solid #0981ff;
  // margin-bottom: 10px;
}
.flex {
  display: flex;
  align-items: center;
}
.flex1{
  flex: 1;
}
.flex-jb {
  justify-content: space-between;
}

.faultBtn {
    width: 208px;
    height: 34px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #e4ecfd;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 16px 0;
    .active {
      text-align: center;
      width: 50%;
      height: 30px;
      font-size: 12px;
      color: #0981ff;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 30px;
      background: #f2f8ff;
      border-radius: 4px;
    }

    .none {
      text-align: center;
      width: 50%;
      height: 30px;
      font-size: 12px;
      color: #333333;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 30px;
      border-radius: 4px;
    }
  }
</style>